import React from 'react';

const FormInput = ({ id, label, type, placeholder, onChange, value }) => {
  // Ensure value is always a defined string, even if passed as undefined or null
  const inputValue = value === undefined || value === null ? '' : value;
  
  return (
    <div className="mb-6">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      
      {type === 'textarea' ? (
        <textarea
          id={id}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
          placeholder={placeholder}
          rows={4}
          onChange={onChange}
          value={inputValue}
        />
      ) : (
        <input
          id={id}
          type={type}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
          placeholder={placeholder}
          onChange={onChange}
          value={inputValue}
        />
      )}
    </div>
  );
};

export default FormInput;